import { Button } from '@mui/material'
import React from 'react'

export default function ButtonComponent({classname, children, ...rest}) {
    return (
        <>
            <Button className={classname} {...rest}>{children}</Button>
        </>
    )
}
